import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import green from "@material-ui/core/colors/green";
//import AutoSelect from 'react-select';
import { connect } from "react-redux";
import { searchFrame } from "../../reducers/search";
import { dashboardSelected,dashboardSubFrame } from '../../reducers/dashboard'

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    padding: "10px"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 200,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    //width: 200
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  button: {
    margin: theme.spacing.unit
  },
  padding5px: {
    display: "flex",
    flexWrap: "wrap",
    padding: "5px",
    margin: "10px"
  },
  cssGreen: {
    color: theme.palette.getContrastText(green[500]),
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700]
    }
  },
  titlePanel: {
    backgroundColor: green[500],
    color: theme.palette.getContrastText(green[500])
  },
  selectStyles: {
    input: base => ({
      ...base,
      color: theme.palette.text.primary,
      "& input": {
        font: "inherit"
      }
    })
  },
  txtBlack : {
    color : "#000000",
  }
});

class RouteSelect extends Component {
  state = {
    value : []
  };
  renderMenuItem = () => {
    let self = this;
    if(this.props.dashboard_route){
      var menuItem = this.props.dashboard_route;
      return menuItem.map(function(value, index) {


        return (
          <MenuItem key={value} value={value}>
            {/*<Checkbox checked={self.state.value.indexOf(value) > -1} />*/}
            <Checkbox checked={self.props.search_frame.route && self.props.search_frame.route.indexOf(value) > -1 ? 'checked' : ''} />
            <ListItemText primary={value} />
          </MenuItem>
        );
      });
    }
    else 
      return null;
  }
  handleChange = (event) =>{
    this.setState({ value: event.target.value });
    this.props.searchFrame({...this.props.search_frame,route:event.target.value });
    //this.props.dashboardSelected(null); 
    //this.props.dashboardSubFrame([]); 
  }
  render() {
    const { classes } = this.props;
    return (
        <FormControl required fullWidth className={classes.textField}>
            <InputLabel shrink htmlFor="route-required" className={classes.txtBlack}>
            ROUTE
            </InputLabel>
            <Select
              multiple
              testing="select-route"
              name="route"
              value={this.props.search_frame.route ? this.props.search_frame.route : []}
              onChange={this.handleChange}
              renderValue={selected => selected.join(', ')}
              inputProps={{
                  id: "route-required"
              }}
            >
              {this.renderMenuItem()}
            </Select>
        </FormControl>
    );
  }
}
const mapStateToProps = function(state) {
  return {
    dashboard_route : state.dashboard.dashboard_route,
    search_frame : state.search.search_frame,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    searchFrame: status => dispatch(searchFrame(status)),
    dashboardSelected : payload => dispatch(dashboardSelected(payload)),
    dashboardSubFrame : payload => dispatch(dashboardSubFrame(payload)),
    dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(RouteSelect));
